/**
 *
 * @filename src/pages/chatArea/chatBox/ChatBoxBody/MessageList/MessageItem/contents/faqCard/index.tsx
 * @author  tujiawei <jiaweitu@marchthepolo.com>
 * @date 2025-10-15 10:40:54
 */

import { FC } from 'react'
import { IMessageItemProps } from '../../interface'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'
import { Button } from 'antd'
import { LOCALE_KEYS } from '@/constant/faq'
import { useFAQModal } from '@/components/FAQModal'
import { CONVERSATION_MESSAGE_CONTENT_TYPE } from '@/constant'
import { useConversationContext } from '@/pages/chatArea/context'
import aegis from '@/utils/aegis'

const getTextMessages = (props: IMessageItemProps) => {
	try {
		const allMessages = props?.info?.messageExtra || []

		return allMessages
			.filter(
				(item: IMessageItemProps['info']) =>
					item.content_type == CONVERSATION_MESSAGE_CONTENT_TYPE.TEXT_MESSAGE
			)
			.slice(0, 3) as IMessageItemProps['info'][]
	} catch (e) {
		try {
			aegis.error({
				msg: `FAQ message format error\n${JSON.stringify(props?.info?.messageExtra)}`
			})
			aegis.error(e)
		} catch (e) {}
		return []
	}
}

const FaqCard: FC<IMessageItemProps> = props => {
	const { t } = useTranslation()
	const { conversationInfo } = useConversationContext()

	const textMessages = getTextMessages(props).reverse()

	const customerName = conversationInfo?.name
	const shopName = conversationInfo?.shop?.alias || conversationInfo?.shop?.name

	const { show, contextHolder } = useFAQModal()

	return (
		<div
			className={classNames(
				'bg-white',
				'mx-auto mb-[10px] p-[10px] border border-[#eaeaea] border-solid rounded-[4px]'
			)}
		>
			<div
				className={classNames(
					'mb-[10px]',
					'border',
					'border-t-0',
					'border-l-0',
					'border-r-0',
					'border-solid',
					'border-[#eaeaea]'
				)}
			>
				{t(LOCALE_KEYS.HISTORY)}
			</div>
			<div className={classNames('flex items-center gap-[8px] bg-[#FAFAFA] p-[8px] rounded-[4px]')}>
				<div className={classNames('min-w-[200px] text-[#666]')}>
					{textMessages.map((item, index) => (
						<div key={index}>
							{item.role == 'customer' ? customerName : shopName}: {item.message}
						</div>
					))}
				</div>
			</div>
			<Button
				type="link"
				className={classNames('!pl-0')}
				onClick={() => {
					if (!Array.isArray(props?.info?.messageExtra)) {
						try {
							aegis.error(
								`FAQ message is not array\n${conversationInfo?.conversation_no}\n${JSON.stringify(
									props?.info?.messageExtra
								)}`
							)
						} catch (e) {}
						return
					}
					show({
						// @ts-ignore
						messages: props?.info?.messageExtra || []
					})
				}}
			>
				{t(LOCALE_KEYS.VIEW_ALL)}
			</Button>
			{contextHolder}
		</div>
	)
}

export default FaqCard
